import WebStorage from './aspects/web-storage';
import Ctx from './core/context';
import HornConfigGetter from './core/horn-config-getter';
import HornLite from './core/HornLite';
import request from './aspects/web-request';
var ctx = new Ctx();
var webStorage = new WebStorage(ctx);
var hornConfigGetter = new HornConfigGetter(ctx, request);
/** horn lite 版本 */
var horn = new HornLite(ctx, webStorage, hornConfigGetter);
horn.create = function () {
    var ctx2 = new Ctx();
    var configGet = new HornConfigGetter(ctx2, request);
    return new HornLite(ctx2, new WebStorage(ctx2), configGet);
};
export default horn;
//# sourceMappingURL=web-lite.js.map